export default class LazyHelper {
    static addScriptFile(href, id, addToHead, async = true) {
        if (LazyHelper.doesScriptExists(href)) {
            return;
        }
        let ev1 = document.createElement('script');
        ev1.src = href;
        ev1.async = async;
        ev1.setAttribute('id', id);
        ev1.classList.add('optanon-category-C0001');
        if (addToHead) {
            document.head.appendChild(ev1);
        }
        else {
            document.body.appendChild(ev1);
        }

        return ev1;
    }

    static addCssFile(href, addToHead) {
        let css = document.createElement('link');
        css.rel = 'stylesheet';
        css.type = 'text/css';
        css.href = href;
        css.media = 'all';
        css.classList.add('optanon-category-C0001');

        if (addToHead) {
            document.head.appendChild(css);
        }
        else {
            document.body.appendChild(css);
        }
    }

    static waitJqueryToLoad(method) {
        if (window.$) {
            method();
        } else {
            setTimeout(function () { LazyHelper.waitJqueryToLoad(method); }, 100);
        }
    }

    static doesScriptExists(url) {
        return document.querySelectorAll(`script[src="${url}"]`).length > 0;
    }
}